import { render, staticRenderFns } from "./UserContactInfo.vue?vue&type=template&id=59e0be27"
import script from "./UserContactInfo.vue?vue&type=script&lang=js"
export * from "./UserContactInfo.vue?vue&type=script&lang=js"
import style0 from "./UserContactInfo.vue?vue&type=style&index=0&id=59e0be27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports